import { useLanguage } from "../context/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer data-testid="site-footer" className="bg-ink text-travertine-light/70 py-10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="font-serif text-lg text-travertine-light">
          Emanuela <span className="italic text-gold">Serena</span>
        </p>
        <p className="text-[10px] font-mono uppercase tracking-[0.25em]">{t.footer}</p>
        <p className="text-[10px] font-mono uppercase tracking-[0.25em]">© {new Date().getFullYear()} · Mela</p>
      </div>
    </footer>
  );
};

export default Footer;
